/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsEmail/AddEmail/Content/Email",
  isInvalid,
  onChange
  
}) {
let selectedEmailValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'email',
})
let selectedEmailIsValidData = fromData.useDataIsValid({ viewPath,
context: 'selected',
path: 'email',
validate: fromValidate.email,
})
let selectedEmailChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'email',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 placeholder="Enter email address"
 type="email"
 label="Email address"
 data="selected.email"
 validate="/Data/validate.js email"
 invalid={!selectedEmailIsValidData}
 onChange={selectedEmailChangeData}
 value={selectedEmailValueData}
/>
{children}
</React.Fragment>)
}